"use client";

/**
 * "For hire · UGX 50,000 / day" on a shop card (2026-09, hire businesses).
 * `solo` replaces the selling price for hire-only items.
 */
import { hireRateLabel, isForHire } from "@/lib/config/hire";

export function HirePriceTag({ product, solo = false, className = "" }: { product: any; solo?: boolean; className?: string }) {
  if (!isForHire(product)) return null;
  const label = hireRateLabel(product, product?.currency || "UGX");
  if (solo) {
    return (
      <span className={`inline-flex items-baseline gap-1.5 text-xs sm:text-sm font-bold text-amber-800 whitespace-nowrap ${className}`}>
        {label}
        <span className="rounded-full bg-amber-100 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-amber-800">for hire</span>
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border border-amber-200 bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold text-amber-800 whitespace-nowrap ${className}`}
    >
      For hire · {label}
    </span>
  );
}

export default HirePriceTag;
